// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/chip-input.js
import ChipSet from "./chip-set"

export default class ChipInput extends ChipSet {
  static componentName = "chip-input"
  static defaults = { ...ChipSet.defaults, removable: true, unique: true, separator: "," }

  constructor(element, config = {}) {
    super(element, config)
    this.input = element.querySelector(".chip-input-field") || document.createElement("input")
    this.input.classList.add("chip-input-field")
    if (!this.input.parentElement) element.append(this.input)
    this.input.readOnly = Boolean(this.config.readonly)
    this.input.disabled = Boolean(this.config.disabled)
    element.classList.toggle("disabled", Boolean(this.config.disabled))
    const resize = () => {
      this.input.size = Math.max(this.input.placeholder.length, this.input.value.length, 1)
    }
    resize()
    this.listen(this.input, "input", resize)
    this.hidden = document.createElement("input")
    this.hidden.type = "hidden"
    if (this.config.name) this.hidden.name = this.config.name
    this.hidden.disabled = Boolean(this.config.disabled)
    element.append(this.hidden)
    this.syncValue()
    this.listen(element, "change.coreui.chip-input", () => this.syncValue())
    this.listen(this.input, "keydown", (event) => {
      if (event.isComposing || this.input.readOnly || this.input.disabled) return
      if (["Enter", this.config.separator].includes(event.key)) {
        event.preventDefault()
        if (this.add(this.input.value)) this.input.value = ""
        resize()
      }
      if (event.key === "Backspace" && !this.input.value) this.chips.at(-1)?.element.focus()
    })
    this.listen(this.input, "paste", (event) => {
      if (this.input.readOnly || this.input.disabled) return
      const value = event.clipboardData.getData("text")
      if (!value.includes(this.config.separator)) return
      event.preventDefault()
      value.split(this.config.separator).forEach((tag) => this.add(tag))
    })
  }

  syncValue() {
    this.hidden.value = this.getValues().join(this.config.separator)
  }
}
